import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Icon from 'flarum/common/components/Icon';
import classList from 'flarum/common/utils/classList';
import extractText from 'flarum/common/utils/extractText';
import Link from 'flarum/common/components/Link';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
const trans = function (key, params) {
  if (params === void 0) {
    params = {};
  }
  return app.translator.trans(`awaresoft-wish-votes.forum.${key}`, params);
};
export default class WishVotesBox extends Component {
  saving = false;
  /** Marker under the pointer or keyboard focus: the markers up to it light up to preview a click. */
  hover = null;
  /** Admin voter list: closed, loading (null) or loaded, and the vote total it was loaded for. */
  votersOpen = false;
  voters = null;
  votersFor = (() => -1)();
  view() {
    const {
      discussion
    } = this.attrs;
    const votes = discussion.wishVoteCount();
    const people = discussion.wishVoterCount();
    const icon = app.forum.attribute('wishVotesIcon');
    if (!discussion.isOpenWish()) {
      return votes > 0 ? m("div", {
        className: "WishVotesBox WishVotesBox--closed"
      }, trans('closed', {
        votes,
        people
      }), this.votersView(votes)) : null;
    }
    const user = app.session.user;
    // Logged in without the permission: counts only. Guests get the markers, a click asks them to log in.
    const canVote = !user || discussion.canWishVote();
    return m("div", {
      className: "WishVotesBox"
    }, m("div", {
      className: "WishVotesBox-total"
    }, m(Icon, {
      name: icon
    }), m("span", {
      className: "WishVotesBox-count"
    }, votes), m("span", null, trans('votes', {
      votes
    }))), m("div", {
      className: "WishVotesBox-people"
    }, trans('people', {
      people
    })), this.votersView(votes), canVote && this.mineView(icon));
  }
  mineView(icon) {
    const {
      discussion
    } = this.attrs;
    const user = app.session.user;
    const mine = discussion.wishVotesMine();
    const cap = app.forum.attribute('wishVotesCap');
    const left = user ? user.wishVotesLeft() : 0;
    const lit = this.hover ?? mine;
    const markers = [];
    for (let i = 1; i <= cap; i++) {
      // Clicking your top marker takes that vote back; any other marker sets your votes to its number.
      const target = i === mine ? i - 1 : i;
      const tooFew = !!user && target - mine > left;
      const label = extractText(i === mine ? trans('remove_vote') : trans('set_votes', {
        count: i
      }));
      markers.push(m("button", {
        type: "button",
        className: classList('WishVotesBox-marker', 'Button--ua-reset', {
          'WishVotesBox-marker--on': i <= lit
        }),
        "aria-label": label,
        title: label,
        "aria-pressed": i <= mine ? 'true' : 'false',
        disabled: this.saving || tooFew,
        onmouseenter: () => this.hover = i,
        onmouseleave: () => this.hover = null,
        onfocus: () => this.hover = i,
        onblur: () => this.hover = null,
        onclick: () => user ? this.setMine(target) : app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'))
      }, m(Icon, {
        name: icon
      })));
    }
    return [m("div", {
      className: "WishVotesBox-mine"
    }, m("span", {
      className: "WishVotesBox-mineLabel"
    }, trans('your_votes')), m("span", {
      className: "WishVotesBox-markers"
    }, markers)), user && m("div", {
      className: "WishVotesBox-left"
    }, trans('left', {
      left,
      allowance: app.forum.attribute('wishVotesAllowance')
    }))];
  }

  /** "Show voters" toggle and list, for actors allowed to see who voted. The list loads when first opened. */
  votersView(votes) {
    if (!app.forum.attribute('canSeeWishVoters') || votes === 0) return null;

    // Votes changed since the list loaded: load it again next time it is shown.
    if (this.votersFor !== votes) this.voters = null;
    return m("div", {
      className: "WishVotesBox-voters"
    }, m("button", {
      type: "button",
      className: "WishVotesBox-votersToggle Button--ua-reset",
      "aria-expanded": this.votersOpen ? 'true' : 'false',
      onclick: () => this.toggleVoters(votes)
    }, m(Icon, {
      name: this.votersOpen ? 'fas fa-caret-down' : 'fas fa-caret-right'
    }), trans(this.votersOpen ? 'hide_voters' : 'show_voters')), this.votersOpen && (this.voters === null ? m(LoadingIndicator, {
      size: "small",
      display: "block"
    }) : m("ul", {
      className: "WishVotesBox-voterList"
    }, this.voters.map(voter => m("li", null, m(Link, {
      href: app.route('user', {
        username: voter.slug
      }),
      className: "WishVotesBox-voter"
    }, voter.avatarUrl ? m("img", {
      className: "Avatar WishVotesBox-avatar",
      src: voter.avatarUrl,
      alt: "",
      loading: "lazy"
    }) : m("span", {
      className: "Avatar WishVotesBox-avatar"
    }, voter.displayName.charAt(0).toUpperCase()), m("span", {
      className: "WishVotesBox-voterName"
    }, voter.displayName), m("span", {
      className: "WishVotesBox-voterAmount"
    }, trans('voter_votes', {
      count: voter.amount
    }))))))));
  }
  toggleVoters(votes) {
    this.votersOpen = !this.votersOpen;
    if (!this.votersOpen || this.voters !== null && this.votersFor === votes) return;
    this.voters = null;
    this.votersFor = votes;
    app.request({
      method: 'GET',
      url: `${app.forum.attribute('apiUrl')}/discussions/${this.attrs.discussion.id()}/wish-voters`
    }).then(response => {
      if (this.votersFor === votes) this.voters = response.data;
    }).catch(() => this.votersOpen = false).finally(() => m.redraw());
  }
  async setMine(count) {
    // The disabled markers only show after the next redraw, so a second click can still land in between.
    if (this.saving) return;
    this.saving = true;
    this.hover = null;
    try {
      await this.attrs.discussion.save({
        wishVotesMine: count
      });
      // The balance moved on the server.
      await app.store.find('users', app.session.user.id());
    } catch {
      // Flarum already showed the server's message as an alert, and any further request would dismiss it.
    }
    this.saving = false;
    m.redraw();
  }
}
flarum.reg.add('awaresoft-wish-votes', 'forum/components/WishVotesBox', WishVotesBox);